import type { ValidationItem } from '../../creativestudio/framework';
import { cn } from '../../lib/cn';
import { Button } from '../ui/Button';

type Props = { items?: ValidationItem[] };

export function QualityValidationPanel({ items = [] }: Props) {
  const passed = items.filter((i) => i.passed).length;
  const failed = items.filter((i) => !i.passed);

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between text-sm">
        <span className="text-success-600">Passed: <strong>{passed}</strong> / {items.length}</span>
        {failed.length > 0 && (
          <Button variant="secondary" size="sm">Auto-regenerate ({failed.length})</Button>
        )}
      </div>
      <div className="grid gap-2 sm:grid-cols-2">
        {items.map((item) => (
          <div
            key={item.label}
            className={cn(
              'rounded-lg border p-3 text-sm',
              item.passed
                ? 'border-success-200 bg-success-50/50 dark:border-success-900 dark:bg-success-950/20'
                : 'border-error-200 bg-error-50/50 dark:border-error-900 dark:bg-error-950/20',
            )}
          >
            <div className="flex items-center justify-between">
              <span className="font-medium">{item.label}</span>
              <span className={cn('text-xs font-semibold', item.passed ? 'text-success-600' : 'text-error-600')}>
                {item.score}%
              </span>
            </div>
            <p className="mt-1 text-xs text-slate-500">{item.detail}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
